module.exports = __webpack_public_path__ + "img/dengji2.c2eae4d8.png";